import { create } from 'zustand';

export interface TimeEntry {
  id: number;
  projectId: number;
  projectName: string;
  date: string;
  hours: number;
  notes: string;
  resourceId: number;
  resourceName: string;
}

interface TimeEntryStore {
  entries: TimeEntry[];
  addEntry: (entry: Omit<TimeEntry, 'id'>) => void;
}

export const useTimeEntryStore = create<TimeEntryStore>((set) => ({
  entries: [
    {
      id: 1,
      projectId: 1,
      projectName: 'Identity Federation Hub',
      date: '2023-08-15',
      hours: 6,
      notes: 'Initial architecture planning',
      resourceId: 1,
      resourceName: 'Sarah Chen'
    },
    {
      id: 2,
      projectId: 2,
      projectName: 'Zero Trust Implementation',
      date: '2023-08-15',
      hours: 4,
      notes: 'Security requirements gathering',
      resourceId: 1,
      resourceName: 'Sarah Chen'
    }
  ],
  addEntry: (entry) => 
    set((state) => ({
      entries: [...state.entries, { ...entry, id: state.entries.length + 1 }]
    }))
}));